import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ClassTemplate } from '../models/classTemplate';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class ClassTemplateService {

  private classTemplateApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.classTemplateApiUrl = this.appSettings.DB_API_ENDPOINT + 'class_templates/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllClassTemplates(): Promise<Array<ClassTemplate>> {
    return  this.http.get(this.classTemplateApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public getClassTemplatesOwnedBy(ownedBy: string) {
    return  this.http.get(this.classTemplateApiUrl + 'owned_by/' + ownedBy, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addGymToClassTemplate(classTemplate: string, gymId: string) {
    return this.http.post(this.classTemplateApiUrl + classTemplate + '/gym/' + gymId, null, this.appSettings.apiOptions).toPromise();
  }

  public addClassTemplate(editClassTemplate): Observable<any> {
    return this.http.post(this.classTemplateApiUrl, editClassTemplate, this.appSettings.apiOptions).map(this.getDataInJson);
  }

  public delClassTemplate(id): Observable<any> {
    return this.http.delete(this.classTemplateApiUrl + id, this.appSettings.apiOptions);
  }

  public editClassTemplate(editClassTemplate): Observable<any> {
    return this.http.put(this.classTemplateApiUrl + editClassTemplate._id, editClassTemplate, this.appSettings.apiOptions);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/class-template.service.ts